///-- THIS FILE IS GENERATED --///
export enum TableLayout {

    TABLE_AUTO = "pinata-table-auto",

    TABLE_FIXED = "pinata-table-fixed",

}